import CryptoJS from 'crypto-js';

const CALLBACK_HASH_SECRET_KEY = process.env.REACT_APP_SECRET_KEY;

function messageFrom(data) {
  const base = typeof data === 'object' && data !== null ? { ...data } : { value: data };
  delete base.userHmac;
  delete base.hmac;
  delete base.mac;

  if (Array.isArray(base.actions)) {
    base.actions = base.actions
      .map((action) =>
        Object.keys(action)
          .sort()
          .map((key) => action[key])
          .join('')
      )
      .join('');
  }

  return Object.keys(base)
    .sort()
    .map((key) => base[key])
    .join('');
}

export function createNewHmac(data) {
  if (!CALLBACK_HASH_SECRET_KEY) {
    throw new Error("HMAC Secret Key is missing in environment variables.");
  }

  const hashResp = CryptoJS.SHA256(CALLBACK_HASH_SECRET_KEY);
  const hmacResp = CryptoJS.HmacSHA256(messageFrom(data), hashResp);
  return CryptoJS.enc.Hex.stringify(hmacResp);
}

export function verifyHmac(payload) {
  if (!payload || typeof payload !== 'object') return false;
  return createNewHmac(payload) === payload.hmac;
}

function requestPath(url) {
  try {
    return new URL(url, window.location.origin).pathname;
  } catch (e) {
    return String(url || '').split('?')[0];
  }
}

function headerValue(headers, name) {
  if (!headers) return '';
  if (typeof headers.get === 'function') {
    return headers.get(name) || headers.get(name.toLowerCase()) || '';
  }
  return headers[name] || headers[name.toLowerCase()] || '';
}

export function attachRequestSecurity(config) {
  if (!config) return config;
  const headers = config.headers || (config.headers = {});
  const body = config.data;
  const isForm = typeof FormData !== 'undefined' && body instanceof FormData;
  const bodyHmac = !isForm && body && typeof body === 'object' ? body.userHmac : undefined;
  if (headerValue(headers, 'userHmac') || bodyHmac) return config;

  const method = String(config.method || 'GET').toUpperCase();

  if (method === 'GET' || method === 'HEAD' || method === 'DELETE') {
    const token = String(headerValue(headers, 'Authorization')).trim();
    if (!token) return config;
    const time = String(Date.now());
    const nonce = window.crypto && window.crypto.randomUUID
      ? window.crypto.randomUUID()
      : `${time}-${Math.random().toString(16).slice(2)}`;
    const path = requestPath(config.url);
    const userHmac = createNewHmac({ token, time, nonce, path, method });
    if (typeof headers.set === 'function') {
      headers.set('userHmac', userHmac);
      headers.set('x-request-time', time);
      headers.set('x-request-nonce', nonce);
    } else {
      headers.userHmac = userHmac;
      headers['x-request-time'] = time;
      headers['x-request-nonce'] = nonce;
    }
    return config;
  }

  if (method === 'POST' || method === 'PUT' || method === 'PATCH') {
    if (isForm || !body || typeof body !== 'object') return config;
    const time = String(Date.now());
    const nonce = window.crypto && window.crypto.randomUUID
      ? window.crypto.randomUUID()
      : `${time}-${Math.random().toString(16).slice(2)}`;
    const path = requestPath(config.url);
    body.time = time;
    body.nonce = nonce;
    body.path = path;
    body.method = method;
    const payload = { ...body };
    delete payload.userHmac;
    body.userHmac = createNewHmac(payload);
    config.data = body;
  }

  return config;
}
